import { Link } from "react-router-dom";
import { Compass, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion-primitives";

export default function TransportTeaser() {
  return (
    <Reveal>
      <div className="flex h-full flex-col border border-navy/10 bg-white p-8 transition-all duration-500 hover:border-bermuda hover:shadow-xl hover:shadow-navy/5" data-testid="transport-teaser">
        <span className="flex h-10 w-10 items-center justify-center rounded-full bg-ocean-light text-ocean">
          <Compass size={17} strokeWidth={1.5} />
        </span>
        <h3 className="mt-5 font-serif text-[22px] leading-tight text-navy">How Should You Get Around Bermuda?</h3>
        <p className="mt-3 flex-1 text-[13px] leading-relaxed text-navy/60">
          Bus, ferry, taxi, ride share or electric microcar? Take our 60-second quiz and find your Bermuda transport match.
        </p>
        <Link to="/guest-tools/getting-around-bermuda" data-testid="transport-teaser-btn" className="group mt-6 inline-flex w-fit items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-navy transition-colors hover:text-bermuda-dark">
          Take the Quiz <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </div>
    </Reveal>
  );
}
